import { Box, Chip, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { OwnershipEntry } from "../../types/Ownership";
import { getValueDisplay } from "../../data/utilities";
import { DELTA_ACCENT, TEXT_SECONDARY } from "../colors";

export const OwnershipTable = (props: { entries: OwnershipEntry[] }) => {
  const { entries } = props;

  return (
    <Box style={{ padding: 20 }}>
      {entries.map((entry, index) => (
        <Box
          key={entry.company_number || index}
          style={{ padding: 16, marginBottom: 12, borderBottom: "1px solid #E2E2E7" }}
        >
          {entry.company_number ? (
            <Link
              to={"/company/" + entry.company_number}
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <Typography variant="subtitle1" style={{ color: DELTA_ACCENT }}>
                {entry.company_name}
              </Typography>
            </Link>
          ) : (
            <Typography variant="subtitle1">{entry.company_name}</Typography>
          )}

          {entry.company_number && (
            <Typography variant="body2" style={{ color: TEXT_SECONDARY }}>
              Company Number: {entry.company_number}
            </Typography>
          )}

          {Array.isArray(entry.natures_of_control) && entry.natures_of_control.length > 0 && (
            <Box style={{ marginTop: 8, display: "flex", flexWrap: "wrap", gap: 6 }}>
              {entry.natures_of_control.map((nature) => (
                <Chip key={nature} label={getValueDisplay(nature)} variant="outlined" size="small" />
              ))}
            </Box>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default OwnershipTable;
